import { createSelector } from 'reselect';

// Selectors
import { getGUID } from 'store/reducers/userInteractions/selectors';
import {
  getVehicle,
  getServices,
  getDeclinedServices,
  getServicePointParams,
  getTransportationOption
} from 'store/reducers/appointment/selectors';

// Utils
import { isObjEmpty } from 'utils/varValidation';
import { getTranspOptionInfo } from '../appointment/selectors';

const scheduleServiceProvider = 'Xtime Service Scheduler';

export const getShiftServiceStartObj = createSelector(getGUID, guid => {
  return {
    ScheduleServiceSessionId: guid,
    scheduleServiceProvider,
    events: 'scheduleServiceStart'
  };
});

export const getShiftServiceImpressionObj = createSelector(getGUID, guid => {
  return {
    scheduleServiceSessionId: guid,
    scheduleServiceProvider,
    events: 'scheduleServiceImpression'
  };
});

export const getShiftTransportShownObj = createSelector(getGUID, guid => {
  return {
    scheduleServiceSessionId: guid,
    scheduleServiceProvider,
    scheduleServiceTransportType: '',
    events: 'scheduleServiceTransportShown'
  };
});

export const getShiftTransportStartObj = createSelector(
  getGUID,
  getTransportationOption,
  getTranspOptionInfo,
  (guid, transportOption, transpOptionInfo) => {
    const transportType = transportOption
      ? transportOption
      : transpOptionInfo
        ? transpOptionInfo.data
        : '';

    return {
      scheduleServiceSessionId: guid,
      scheduleServiceProvider,
      scheduleServiceTransportType: transportType,
      events: 'scheduleServiceTransportStart'
    };
  }
);

export const getShiftTransportFinishObj = createSelector(
  getGUID,
  getTransportationOption,
  (guid, transportOption) => {
    return {
      scheduleServiceSessionId: guid,
      scheduleServiceProvider,
      scheduleServiceTransportType: transportOption,
      events: 'scheduleServiceTransportFinish'
    };
  }
);

export const getShiftServiceApptSetObj = createSelector(
  getGUID,
  getVehicle,
  getServices,
  getDeclinedServices,
  getServicePointParams,
  (guid, vehicle, apptServices, declined, menus) => {
    const services = [];
    apptServices.forEach(service => {
      services.push({
        title: service.name,
        category: service.serviceKind,
        msrp: service.price
      });
    });
    declined.forEach(service => {
      services.push({
        title: service.name,
        category: 'repair',
        msrp: service.price
      });
    });
    if (!isObjEmpty(menus)) {
      services.push({
        title: menus.menuType.description,
        category: 'menuType',
        msrp: menus.menuType.price
      });
    }
    return {
      ScheduleServiceSessionId: guid,
      scheduleServiceProvider,
      serviceVehicleYear: vehicle.year,
      serviceVehicleMake: vehicle.make,
      serviceVehicleModel: vehicle.model,
      serviceVehicleVIN: vehicle.vin,
      serviceVehicleMileage: vehicle.mileage,
      services,
      events: 'scheduleServiceApptSet'
    };
  }
);



// WEBPACK FOOTER //
// ./src/store/reducers/clickTracking/selectors.js